import { useId } from "@react-aria/utils";
import type { OverlayTriggerProps } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type TooltipPopoverProps = Omit<OverlayTriggerProps, "overlay"> & {
  tooltipText?: string;
};

export const TooltipPopover = ({
  children,
  placement = "right",
  tooltipText,
  ...rest
}: TooltipPopoverProps): JSX.Element => {
  const tooltipId = useId();

  return (
    <OverlayTrigger
      {...rest}
      placement={placement}
      overlay={
        <Tooltip id={tooltipId} {...rest}>
          {tooltipText}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};
